import Vapi from 'vuex-rest-api';
import axios from '@/api/axios';

const store = new Vapi({
  axios,
  state: {
  },
})
  .get({
    action: 'getSystemDictionaries',
    property: 'dict',
    path: () => '/discovery/dictionaries',
  })
  .getStore();

export default store;
